import React from "react";

/**
 * Logomark TotalKlick Hub — stile tecnologico/network.
 * Nodo centrale + 3 nodi satellite connessi: richiama la struttura
 * multi-network (SuperAdmin → Casa Madre → Rivenditori) in modo semplice e leggibile.
 *
 * variant="brand" → tile pieno gradiente copper (su sfondi chiari/scuri)
 * variant="mono"  → glifo monocromatico (su sfondi colorati/traslucidi, es. hero scuro)
 */
export default function TotalKlickLogo({ size = 36, variant = "brand", className = "" }) {
  const gradId = `tk-hub-grad-${variant}`;
  const isMono = variant === "mono";

  return (
    <div
      className={`shrink-0 rounded-[10px] flex items-center justify-center ${isMono ? "bg-white/15 backdrop-blur" : "bg-gradient-to-br from-[#E08A4F] via-[#C25934] to-[#9B3F23]"} ${className}`}
      style={{ width: size, height: size }}
    >
      <svg width={size * 0.62} height={size * 0.62} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id={gradId} x1="4" y1="6" x2="27" y2="24" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor={isMono ? "#FFFFFF" : "#FFE8D6"} />
            <stop offset="1" stopColor={isMono ? "#FFFFFF" : "#FFFFFF"} stopOpacity={isMono ? 1 : 0.85} />
          </linearGradient>
        </defs>
        {/* connessioni hub → satelliti */}
        <path d="M16 15 L16 6.4" stroke={`url(#${gradId})`} strokeWidth="1.7" strokeLinecap="round" opacity="0.9" />
        <path d="M16 15 L7.4 21" stroke={`url(#${gradId})`} strokeWidth="1.7" strokeLinecap="round" opacity="0.9" />
        <path d="M16 15 L24.6 21" stroke={`url(#${gradId})`} strokeWidth="1.7" strokeLinecap="round" opacity="0.9" />
        {/* nodi satellite */}
        <circle cx="16" cy="6" r="2.6" fill={`url(#${gradId})`} />
        <circle cx="7.2" cy="22" r="2.6" fill={`url(#${gradId})`} />
        <circle cx="24.8" cy="22" r="2.6" fill={`url(#${gradId})`} />
        {/* nodo centrale (hub) */}
        <circle cx="16" cy="15" r="4" fill={isMono ? "#FFFFFF" : "#FFFFFF"} />
      </svg>
    </div>
  );
}
